module.exports = __webpack_public_path__ + "img/alabama-tech-logo.e926a933.jpg";